<template>
  <div @click="redirectHome" class="logo-wrapper" :class="{ small, large }">
    <img class="logo-image" :src="logo" alt="Dremca Insurance Logo" />
  </div>
</template>

<script>
export default {
  name: "FullLogo",
  props: {
    large: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    logo: {
      type: String,
      default: "../../images/full-logo.png"
    }
  },
  computed: {
    imageSelect: function() {
      return "../../images/full-logo.png";
    }
  },
  data() {
    return {};
  },
  methods: {
    redirectHome() {
      this.$emit("click")
      this.$router
        .push("/home")
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.logo {
  &-image {
    height: $logo-size-lg;
    width: auto;
    flex: none;
    flex-shrink: 0;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  &-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: $padding-sm;
    justify-content: flex-start;
    cursor: pointer;

    &.large .logo {
      &-image {
        height: $logo-size-lg;
      }
    }

    &.small .logo {
      &-image {
        height: $logo-size-sm;
      }
    }
  }
}
</style>
